import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IRequisitionItemWorkflowFields {
		id?: any;
		requisitionItemId?: any;
		workflowId?: any;
		datestamp?: any;
		userId?: any;
		comments?: any;
}

export class RequisitionItemWorkflowFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public requisitionItemId: IEntityModelField = { name: "requisitionItemId", displayName: "Requisition Item Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public workflowId: IEntityModelField = { name: "workflowId", displayName: "Workflow Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public userId: IEntityModelField = { name: "userId", displayName: "User Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public comments: IEntityModelField = { name: "comments", displayName: "Comments", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.requisitionItemId);
		this.push(this.workflowId);
		this.push(this.datestamp);
		this.push(this.userId);
		this.push(this.comments);
	}
}

export class RequisitionItemWorkflowDTO implements IEntityModel {
	protected requisitionItemWorkflowName: string = "RequisitionItemWorkflowModel";
	protected requisitionItemWorkflowKeyField: string = "id";
	protected requisitionItemWorkflowDisplayName: string = "Requisition Item Workflow|Requisition Item Workflows";
	protected requisitionItemWorkflowFields = new RequisitionItemWorkflowFields();
	public get name(): string { return this.requisitionItemWorkflowName };
	public get keyField(): string { return this.requisitionItemWorkflowKeyField };
	public get displayName(): string { return this.requisitionItemWorkflowDisplayName };
	public get fields(): RequisitionItemWorkflowFields { return this.requisitionItemWorkflowFields };

	constructor() {};
}
